/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import Cookies from 'universal-cookie'
import { AppContext } from 'store/context'
import { ActionTypes } from 'store/actions'
import ContractEntity from 'utils/__interfaces/Perimeter/ContractEntity'
import { PERIMETER_MODE } from 'utils/__enums/Common/Screen'
import { truncateString } from 'utils/Common/ts-utils'
import MAINTENANCE_TYPE from 'utils/__enums/SuperAdministration/Maintenance'
import BandeauPerimetre from 'components/molecules/BandeauPerimetre'
import SvgIcon from 'components/Icons/SvgIcon'
import SmartSelectOrganization from './SmartSelectOrganization'
import SmartSelectContract from './SmartSelectContract'

function PerimeterFilter() {
  const { t } = useTranslation()
  const {
    state: {
      organization,
      contract,
      impersonnation: { isImpersonnation },
      ui: { perimeterFilterMode },
    },
    dispatch,
  } = useContext(AppContext)

  const NEW_PERIMETER_FILTER = Boolean(
    parseInt(process?.env?.REACT_APP_NEW_PERIMETER_FILTER || '1', 10)
  )
  // STATE
  const [impersonnationClass, setImpersonnationClass] = useState('')
  const [filterResetClass, setFilterResetClass] = useState(
    'perimeter-filter__reset'
  )
  const [displayButtonClass, setDisplayButtonClass] = useState(
    'perimeter-filter__display-button'
  )
  const [forceReset, setForceReset] = useState(false)
  const [forceUnfold, setForceUnfold] = useState(false)
  const [organizationSetted, setOrganizationSetted] = useState(
    organization.items.length > 0
  )
  const [initialValue, setInitialValue] = useState<ContractEntity[]>([])

  const [organisationLibelle, setOrganisationLibelle] = useState(
    'Organisations'
  )
  const [contractLabel, setContractLabel] = useState(
    'perimeterfilter.label.contracts'
  )

  const [disabledSearch, setDisabledSearch] = useState<boolean>(false)

  const maintenanceMode = localStorage.getItem(
    `maintenanceMode${MAINTENANCE_TYPE.ALL}`
  )
  const isInMaintenance =
    Number(`${process.env.REACT_APP_MAINTENANCE}`) === 1 ||
    maintenanceMode === 'true'

  // HANDLER
  const switchMode = () => {
    dispatch({
      type: ActionTypes.SWITCH_PERIMETER_FILTER_MODE,
      payload: null,
    })
  }
  useEffect(() => {
    setForceReset(!forceReset)
    setOrganizationSetted(false)
    if (isImpersonnation) {
      setImpersonnationClass('impersonate')
      setFilterResetClass('perimeter-filter__reset-impersonate')
      setDisplayButtonClass('perimeter-filter__display-button-impersonate')
    } else {
      setImpersonnationClass('')
      setFilterResetClass('perimeter-filter__reset')
      setDisplayButtonClass('perimeter-filter__display-button')
    }
  }, [isImpersonnation])

  useEffect(() => {
    if (perimeterFilterMode === PERIMETER_MODE.DECREASED_MODE) {
      if (organization.items.length > 1) {
        setOrganisationLibelle(
          `${organization.items.length} ${t(
            'perimeterfilter.label.orgaSelected'
          )}`
        )
      } else if (organization.items.length === 1) {
        setOrganisationLibelle(
          `${t('perimeterfilter.label.oneOrgaSelected')} ${
            organization.items[0].name
          }`
        )
      } else {
        setOrganisationLibelle(t('perimeterfilter.label.organizations'))
      }

      if (contract.items.length > 1) {
        setContractLabel(
          `${contract.items.length} ${t(
            'perimeterfilter.label.contractsSelected'
          )}`
        )
      } else if (contract.items.length === 1) {
        setContractLabel(
          `${t('perimeterfilter.label.oneContractSelected')} ${
            contract.items[0].name
          }`
        )
      } else {
        setContractLabel(t('perimeterfilter.label.contracts'))
      }
    } else {
      setContractLabel(t('perimeterfilter.label.contracts'))
      setOrganisationLibelle(t('perimeterfilter.label.organizations'))
    }
  }, [organization, contract, perimeterFilterMode])

  const resetFilter = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation()
    // clear cookies
    const cookies = new Cookies()
    cookies.remove('chosenContrat', { path: '/' })
    cookies.remove('chosenOrganization', { path: '/' })
    dispatch({
      type: ActionTypes.RESET_PERIMETER_FILTER,
    })
    setForceReset(!forceReset)
    setInitialValue([])
    setOrganizationSetted(false)
  }

  const handleOrganizationsSetted = () => {
    setForceUnfold(!forceUnfold)
    setOrganizationSetted(true)
  }

  return (
    <>
      {NEW_PERIMETER_FILTER ? (
        <>
          <BandeauPerimetre
            resetFilter={resetFilter}
            filterResetClass={filterResetClass}
            classe={impersonnationClass}
          >
            <div
              className="perimeter-filter__organizations"
              id="organisationId"
            >
              <div>{truncateString(organisationLibelle, 50)}</div>
              <SmartSelectOrganization
                forceReset={forceReset}
                setForceReset={setForceReset}
                onOrganizationsSetted={handleOrganizationsSetted}
                onSearchContratsValidate={setInitialValue}
                onDisabledSearchContrat={setDisabledSearch}
                searchWithSetContrats={true}
                selectedOrganizations={organization.items}
                isBandeau={true}
              />
            </div>
            <div className="perimeter-filter__contracts" id="contractId">
              <div>{truncateString(contractLabel, 50)}</div>
              <SmartSelectContract
                organizationSetted={organizationSetted}
                initialContrats={initialValue}
                forceReset={forceReset}
                forceUnfold={forceUnfold}
                selectedContrats={contract.items}
                disabledSearch={disabledSearch}
                isBandeau={true}
              />
            </div>
          </BandeauPerimetre>
        </>
      ) : (
        <>
          <div
            className={`perimeter-filter ${
              !isImpersonnation && isInMaintenance ? 'in-maintenance' : ''
            } ${impersonnationClass} ${perimeterFilterMode}`}
          >
            <div className="perimeter-filter__content">
              <div className="perimeter-filter__title">
                {t('perimeterfilter.label.title')}
              </div>
              <div
                className="perimeter-filter__organizations"
                id="organisationId"
              >
                <div>{organisationLibelle}</div>
                <SmartSelectOrganization
                  forceReset={forceReset}
                  setForceReset={setForceReset}
                  onOrganizationsSetted={handleOrganizationsSetted}
                  onSearchContratsValidate={setInitialValue}
                  onDisabledSearchContrat={setDisabledSearch}
                  searchWithSetContrats={true}
                  selectedOrganizations={organization.items}
                  isBandeau={false}
                />
              </div>
              <div className="perimeter-filter__contracts" id="contractId">
                <div>{contractLabel}</div>
                <SmartSelectContract
                  organizationSetted={organizationSetted}
                  initialContrats={initialValue}
                  forceReset={forceReset}
                  forceUnfold={forceUnfold}
                  selectedContrats={contract.items}
                  disabledSearch={disabledSearch}
                  isBandeau={false}
                />
              </div>
              <button
                type="button"
                className={`${filterResetClass}`}
                onClick={resetFilter}
              >
                <span>{t('perimeterfilter.link.reset')}</span>
                <SvgIcon
                  name="iconRight"
                  className={`${filterResetClass}-icon`}
                />
              </button>
            </div>
          </div>
          <div className={`perimeter-filter__display ${perimeterFilterMode}`}>
            <div
              className={`perimeter-filter__display-right ${
                !isImpersonnation && isInMaintenance ? 'in-maintenance' : ''
              } `}
              onClick={switchMode}
            >
              <div className={`${displayButtonClass} perimeter-filter__plus`}>
                {t('perimeterfilter.label.increase')}
                <SvgIcon name="plus" className="perimeter-filter__icon" />
              </div>
              <div className={`${displayButtonClass} perimeter-filter__minus`}>
                {t('perimeterfilter.label.decrease')}
                <SvgIcon name="minus" className="perimeter-filter__icon" />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
export default PerimeterFilter
